/**
 * Created by AB74296 on 9/5/2017.
 */
import React, { Component, useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { HashRouter, Route } from 'react-router-dom';
import BlockUi from '@availity/block-ui';
import IdleTimer from 'react-idle-timer';
import '@availity/block-ui/dist/index.css';
import { Header, IdleTimeOutModal } from '../components/index';
import commonStore from '../stores/commonStore';
import ScrollToTop from '../utilities/scroll';
import Landing from '../../AHAH_Awardee_Form/Landing/Landing';
import ProviderAwardeeInfo from '../../AHAH_Awardee_Form/Provider_Awardee_Info/ProviderAwardeeInfo';
import awardeestore from '../../AHAH_Awardee_Form/stores/awardeestore';
import HousingProfile from '../../AHAH_Awardee_Form/HousingProfile/HousingProfile';
import AdditionalQuestions from '../../AHAH_Awardee_Form/AdditionalQuestions/AdditionalQuestions';
import Acknowledgements from '../../AHAH_Awardee_Form/Acknowledgements/Acknowledgements';
import ReviewAndSubmit from '../../AHAH_Awardee_Form/ReviewAndSubmit/ReviewAndSubmit';
import UploadVoucherReviewSubmit from '../../AHAH_Awardee_Form/ReviewAndSubmit/UploadVoucherReviewSubmit/UploadVoucherReviewSubmit';
import Documentation from '../../AHAH_Awardee_Form/Documentation/Documentation';
import Confirmation from '../../AHAH_Awardee_Form/Confirmation/Confirmation';
import UploadVoucherConfirmation from '../../AHAH_Awardee_Form/Confirmation/UploadVoucherandLandordDocuments/UploadVoucherConfirmation';
import ProviderAndAwardee from '../../AHAH_Awardee_Form/Provider_Awardee_Info/ProviderAndAwardee';
import DocumentationVoucher from '../../AHAH_Awardee_Form/Documentation/DocumentationVoucher';

import '@availity/date/styles.scss';
import ProtectedRoute from './ProtectedRoute';

const timeout = 18 * 10 * 10000
const timeoutAlert = 9 * 10 * 10000
let overLayTimer = null

const IdleTimeoutContainer = () => {
  const [showModal, setShowModal] = useState(false)
  const idleTimer = useRef(null)

  const onActive = (e) => {
    if (idleTimer?.current?.getRemainingTime() > 0)
      // eslint-disable-next-line no-console
      console.log('user is active, time remaining::')
  }

  const onIdle = (e) => {
    setShowModal(true)
    overLayTimer = setTimeout(() => {
      window.location.reload()
    }, timeoutAlert)
  }
  const handleClose = () => {
    setShowModal(false)
    window.location.reload()
    clearTimeout(overLayTimer)
  }
  const handleClose1 = () => {
    setShowModal(false)
  }
  return (
    <>
      <IdleTimer
        ref={idleTimer}
        element={document}
        onActive={onActive}
        onIdle={onIdle}
        debounce={250}
        timeout={parseInt(timeout - timeoutAlert, 10)} />
      <IdleTimeOutModal
        showModal={showModal}
        handleClose={handleClose}
        handleClose1={handleClose1}
      // handleLogout={handleLogout}
      />
    </>
  )
}

@observer
class Layout extends Component {
  renderRootPath = () => {
    return (
      <div>
        <Route exact path="/" component={Landing} />
        <ProtectedRoute exact path="/providerinfo" component={ProviderAwardeeInfo} stepKey="providerinfo" />
        <ProtectedRoute exact path="/housingprofile" component={HousingProfile} stepKey="housingprofile" />
        <ProtectedRoute exact path="/additionalquestions" component={AdditionalQuestions} stepKey="additionalquestions" />
        <ProtectedRoute exact path="/documents" component={Documentation} stepKey="documents" />
        <ProtectedRoute exact path="/acknowledgements" component={Acknowledgements} stepKey="acknowledgements" />
        <ProtectedRoute exact path="/reviewAndSubmit" component={ReviewAndSubmit} stepKey="reviewAndSubmit" />
        <ProtectedRoute exact path="/confirmation" component={Confirmation} stepKey="confirmation" />
        <ProtectedRoute exact path="/providerAndAwardee" component={ProviderAndAwardee} stepKey="providerAndAwardee" />
        <ProtectedRoute exact path="/documentsVoucher" component={DocumentationVoucher} stepKey="documentsVoucher" />
        <ProtectedRoute exact path="/uploadReviewAndSubmit" component={UploadVoucherReviewSubmit} stepKey="uploadReviewAndSubmit" />
        <ProtectedRoute exact path="/uploadvoucherconfirmation" component={UploadVoucherConfirmation} stepKey="uploadvoucherconfirmation" />
      </div>
    );
  };

  render() {
    return (
      <div>
        <IdleTimeoutContainer />
        <Header commonStore={commonStore} />
        <HashRouter basename="/">
          <div className='container'>
            <BlockUi tag="div" blocking={awardeestore.blocking}>
              <ScrollToTop />
              <Route path="/" render={this.renderRootPath} />
            </BlockUi>
          </div>
        </HashRouter>
      </div>
    );
  }
}

export default Layout;